<div class="payment-icon-wrapper">
  <img *ngIf="iconUrl" src="{{ iconUrl }}" />
</div>
